// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"5272b65b","455":"0745a67b"}[chunkId] + ".chunk.js";
};